<div class="engagement-tracking mb-4">
  <h4 class="flex items-center mb-1">
    Tracking
    <button
      mat-icon-button
      color="primary"
      (click)="addNewEngagement()"
      [matTooltip]="'Add new engagement tracking'"
    >
      <mat-icon color="primary">playlist_add</mat-icon>
    </button>
  </h4>
  <div class="engagement-tracking-table-wrapper">
    <table class="engagement-tracking-table relative">
      <thead class="sticky top-0">
        <tr>
          <td class="project">{{ headers.project }}</td>
          <td class="date">{{ headers.date }}</td>
          <td class="description">{{ headers.description }}</td>
          <td class="quantity">{{ headers.quantity }}</td>
          <td class="tags">{{ headers.tags }}</td>
          <td class="person">{{ headers.person }}</td>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let engagement of getSortedEngagements()"
          engagement-tracking-tr
          [engagementTrackingItem]="engagement"
          [params]="params"
          [project]="getProjectFromEngagement(engagement).description"
          [itemProjectId]="getProjectFromEngagement(engagement).id"
          [deleteCallback]="deleteCallback.bind(this)"
        ></tr>
      </tbody>
    </table>
  </div>
</div>
